import React from 'react';
import Survey, { CssNames } from '../../Survey';
import CalendarBookingSurvey from './calendarBooking';
import CalendarBookingWrapper from './calendarBooking.styles';

class CalendarBooking extends React.Component {
  // state = { stage: 0, big5: null, matrix: null };
  //Define a callback methods on survey complete

  onComplete = async (survey, options) => {
    // Write survey results into database
    // console.log('Survey results: ');
    // const { data } = survey;
    // console.log(data);
    // await this.setState(prev => ({ big5: data, stage: prev.stage + 1 }));
    const { data } = survey;
    const { onComplete } = this.props;
    const { DATE, TIME_1, TIME_2 } = data;
    const parsed = { DATE, TIME_1, TIME_2 };
    await onComplete(parsed);
  };

  render() {
    const CalendarBookingModel = new Survey.Model(CalendarBookingSurvey);
    return (
      <CalendarBookingWrapper>
        <div className='edu_header'>
          <img
            className='edu-logo'
            src='https://res.cloudinary.com/dpveipnvx/image/upload/v1564630271/uaimetrics/uai_white.png'
            alt='edu-logo'
          />
        </div>
        <Survey.Survey
          model={CalendarBookingModel}
          css={CssNames}
          onComplete={this.onComplete}
        />
        <div className='Footer'>
          {/* <img
            src="https://res.cloudinary.com/dpveipnvx/image/upload/v1564629089/uaimetrics/Logo_edu-corporate-2.png"
            alt="edu-corporate"
          /> */}
          {/* <img
            className="btg-logo"
            src="https://res.cloudinary.com/dpveipnvx/image/upload/v1564629090/uaimetrics/BTG-Pactual-HP_Logo.jpg"
            alt="btg-pactual"
          /> */}
        </div>
        <div className='PushStickyFooter'></div>
        <div className='Plug'>
          <a
            href='http://www.edumetrics.cl/'
            target='_blank'
            rel='noopener noreferrer'
          >
            EduMetrics
          </a>
        </div>
      </CalendarBookingWrapper>
    );
  }
}

export default CalendarBooking;
